import React from 'react';
import { Box } from 'grommet';
import { BoxProps } from 'grommet/components/Box';

interface PageWrapperProps extends BoxProps {
  children: React.ReactNode | React.ReactNode[];
  vAlign?: BoxProps['justify'];
  pad?: BoxProps['pad'];
}

const PageWrapper = (props: PageWrapperProps): JSX.Element => {
  const {
    children,
    vAlign = 'start',
    pad = { top: 'none', bottom: 'none', right: '25px', left: '50px' },
    margin = { top: 'none', bottom: 'medium', right: 'none', left: 'none' },
    ...styles
  } = props;

  return (
    <Box
      flex
      fill
      align="center"
      justify={vAlign}
      pad={pad}
      margin={margin}
      overflow="auto"
      {...styles}
    >
      {children}
    </Box>
  );
};

PageWrapper.displayName = 'PageWrapper';

export default PageWrapper;
